import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PageRequest} from '../../shared/models/page-request.interface';
import {Observable, throwError} from 'rxjs';
import {HelpInfo} from '../models/help-info.interface';
import {Page} from '../../shared/models/page.interface';
import {environment} from '../../../environments/environment';
import {ApiHttpResponse} from '../../shared/models/api-http-response.interface';
import {catchError, map} from 'rxjs/operators';
import {HelpInfoSearch} from '../models/help-info-search.interface';

const HELP_INFO_API = environment.apiUrl + 'help-info';

@Injectable({
  providedIn: 'root'
})
export class DialogsService {

  constructor(private http: HttpClient) { }

  static buildSearchParams(search: HelpInfoSearch): string {
    let searchParams = '';
    if (search.code && search.code !== '') {
      searchParams += `&code=${search.code}`;
    }
    if (search.title && search.title !== '') {
      searchParams += `&title=${search.title}`;
    }
    return searchParams;
  }

  getAll(search: HelpInfoSearch, pageRequest: PageRequest = {page: 0, size: 100}): Observable<Page<HelpInfo>> {
    let url = `${HELP_INFO_API}?size=${pageRequest.size}&page=${pageRequest.page}`;
    const searchParams = DialogsService.buildSearchParams(search);
    if (pageRequest.sort && pageRequest.direction) {
      url = url + `&sort=${this.getSortCode(pageRequest.sort)},${pageRequest.direction}`;
    }
    return this.http.get<Page<HelpInfo>>(url + searchParams);
  }

  getChartExplanations(search: HelpInfoSearch, pageRequest: PageRequest = {page: 0, size: 100}): Observable<Page<HelpInfo>> {
    let url = `${HELP_INFO_API}/chart-explanations?size=${pageRequest.size}&page=${pageRequest.page}`;
    const searchParams = DialogsService.buildSearchParams(search);
    if (pageRequest.sort && pageRequest.direction) {
      url = url + `&sort=${this.getSortCode(pageRequest.sort)},${pageRequest.direction}`;
    }
    return this.http.get<Page<HelpInfo>>(url + searchParams);
  }

  editDialog(dto: HelpInfo): Observable<ApiHttpResponse<HelpInfo>> {
    return this.http.put<ApiHttpResponse<HelpInfo>>(`${HELP_INFO_API}`, dto)
      .pipe(
        catchError(err => {
          return throwError(err);
        }),
        map((res: ApiHttpResponse<HelpInfo>) => {
          return res;
        })
      );
  }

  private getSortCode(sort: string): string {
    switch (sort) {
      case 'open':
        return 'isReportingAvailable';
      default:
        return sort;
    }
  }
}
